import Body from "./components/Body";
import "./index.scss";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";

type Props = {};

const UploadDocumentScreen = (props: Props) => {
  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  return (
    <section id="financial-group-screen">
      <Body />
    </section>
  );
};

export default UploadDocumentScreen;
